import { render, staticRenderFns } from "./ViewStockLevels.vue?vue&type=template&id=2915c8d0&"
import script from "./ViewStockLevels.vue?vue&type=script&lang=js&"
export * from "./ViewStockLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports